<template>
    <div id="shareInduce" v-show="this.$store.state.sharePage" @click="shareInduce">
        <div class="dialog" >
            <div class="mask"></div>
            <img src="http://shared.youdao.com/dict/market/recite-vocabulary/imgs/tan.png" alt="" class="shareInduce" v-if="!toBrowser" >
            <img src="http://shared.youdao.com/dict/market/recite_word_share/static/jt.png" alt="" class="shareInduce" v-if="toBrowser">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShareInduce',
        props: {
            toBrowser: ''
        },
        methods: {
            shareInduce :function() {
                this.$store.commit('HIDDEN_INDUCE_PAGE')
            }
        }
    }
</script>

<style scoped>
    #shareInduce .dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;        
        bottom: 0;
        z-index: 100;
    }

    #shareInduce .dialog .mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;        
        bottom: 0;
        background-color: #000000;
        filter: alpha(Opacity=60);
        opacity: 0.6;
    }

    #shareInduce .shareInduce {
        width: 3.2rem;
        height: 3.1rem;        
        position: fixed;
        margin: 0.5rem;
        right: 0;
        top: 0;
        display: block;
    }

    #shareInduce p {
        width: 100%;
        text-align: center;
        position: fixed;
        top: 3.4rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        color: #FFFFFF;
        letter-spacing: 0;
    }

    #shareInduce .share_induce {
        width: 3.2rem;
        height: 0.96rem;
        background: #D6463C;
        border-radius: 0.12rem;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #FFFFFF;
        line-height: 0.96rem;
        text-align: center;
        position: fixed;
        top: 4.2rem;
        left: 50%;
        margin-left: -1.6rem;
    }
</style>




// WEBPACK FOOTER //
// src/components/ShareInduce.vue